import _ from 'lodash'

/**
 * 이미지/비디오 주소를 CDN 주소로 변환한다.
 * @param {string} mediaSrc - CDN 주소가 포함되지 않은 이미지/비디오 주소
 * @returns {string} CDN 주소로 변환된 이미지/비디오 주소
 */
export function getCdnUrl (mediaSrc) {
  if (mediaSrc && (mediaSrc.startsWith('blob:') || mediaSrc.startsWith('data:'))) {
    return mediaSrc
  }
  let mediaUrl = process.env.WEB_BASE_URL + '/images/tempLy/noimage.png'
  if (mediaSrc) {
    if (/^https?:\/\//i.test(mediaSrc) || mediaSrc.includes(process.env.CDN_BASE_URL)) {
      mediaUrl = mediaSrc
    } else {
      let url = process.env.CDN_BASE_URL
      url = (mediaSrc.charAt(0) !== '/' ? url + '/' : url) + mediaSrc
      mediaUrl = _.unescape(url)
    }
  }
  return encodeMediaUrl(mediaUrl)
}

/**
 * URL 구조(프로토콜, 도메인, 경로 구분자, 쿼리)는 유지하면서 경로의 각 segment만
 * RFC 3986 방식으로 인코딩한다. encodeURI가 그대로 두는 '+', '#', '&' 등의 문자가
 * CDN에서 공백이나 URL 구분자로 해석되는 문제와 이미 인코딩된 URL의 이중 인코딩을 방지한다.
 *
 * @param {string} url - 인코딩할 미디어 URL
 * @returns {string} 파일 경로가 안전하게 인코딩된 URL
 */
export function encodeMediaUrl (url) {
  if (!url || typeof url !== 'string') {
    return url
  }

  const originMatch = url.match(/^((?:[a-z][a-z\d+.-]*:)?\/\/[^/]*)(.*)$/i)
  const origin = originMatch ? originMatch[1] : ''
  const pathAndQuery = originMatch ? originMatch[2] : url
  const queryIndex = pathAndQuery.indexOf('?')
  const path = queryIndex === -1 ? pathAndQuery : pathAndQuery.slice(0, queryIndex)
  const query = queryIndex === -1 ? '' : pathAndQuery.slice(queryIndex)

  const encodedPath = path
    .split('/')
    .map(encodePathSegment)
    .join('/')

  return origin + encodedPath + query
}

function encodePathSegment (segment) {
  let decodedSegment = segment

  try {
    decodedSegment = decodeURIComponent(segment)
  } catch (e) {
    // 잘못된 '%'가 포함된 경우에도 원문 전체를 안전하게 인코딩한다.
  }

  return encodeURIComponent(decodedSegment).replace(/[!'()*]/g, character =>
    `%${character.charCodeAt(0).toString(16).toUpperCase()}`
  )
}

/**
 * URL 인코딩 여부를 체크한다.
 * @param {string} url - 이미지/비디오 URL
 * @returns {boolean} 인코딩 여부
 */
export function isEncoded (url) {
  try {
    return url !== decodeURIComponent(url)
  } catch (e) {
    return false
  }
}
